import PropTypes from "prop-types";
import { InputAdornment, MenuItem, TextField, Typography } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab"
import { NumericFormat } from "react-number-format";
import { ESTADOS_DO_BRASIL, formatInputValuesToDefault } from "../../../../utils/financialHelper";
import { MaskedTextField } from "../../../../components/FormFields";
import CrudFormPage from "../../../../components/Financial/CrudFormPage";

const FormEmpregados = ({ values, setValues, isDelete: isDisabled, isLoadingSubmit = false }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues({ ...values, [name]: formatInputValuesToDefault(value) });
  }

  const situacaoFuncional = ['Aposentado', 'Ativo', 'Contrato', 'Demitido', 'Experiência', 'Licença', 'Suspenso', 'Terminado']

  return (
    <CrudFormPage isLoadingSubmit={isLoadingSubmit}>
      <div className='linha-campos'>
        <TextField
          label="Nome Completo"
          id="fullName"
          name='fullName'
          value={values.fullName}
          variant="outlined"
          InputLabelProps={{ shrink: true }}
          onChange={handleChange}
          required
          fullWidth
          disabled={isDisabled}
        />
      </div>
      <div className='linha-campos'>
        <MaskedTextField
          mask='999.999.999-999'
          label="CPF"
          id="cpf"
          name='cpf'
          value={values.cpf}
          variant="outlined"
          InputLabelProps={{ shrink: true }}
          onChange={handleChange}
          varibleName='cpfCnpj'
          required
          fullWidth
          style={{ margin: '0' }}
          disabled={isDisabled}
        />
        <TextField
          label="Data de Nascimento"
          id="birthDate"
          name='birthDate'
          value={values.birthDate}
          variant="outlined"
          InputLabelProps={{ shrink: true }}
          onChange={handleChange}
          fullWidth
          disabled={isDisabled}
          type="date"
        />
      </div>
      <div className='linha-campos'>
        <TextField
          label="Telefone"
          id="phone"
          name='phone'
          value={values.phone}
          variant="outlined"
          InputLabelProps={{ shrink: true }}
          onChange={handleChange}
          fullWidth
          disabled={isDisabled}
        />
        <TextField
          label="Email"
          id="email"
          name='email'
          value={values.email}
          variant="outlined"
          InputLabelProps={{ shrink: true }}
          onChange={handleChange}
          fullWidth
          disabled={isDisabled}
        />
      </div>

      <Typography variant="overline">Contratual</Typography>

      <div className='linha-campos'>
        <TextField
          label="Cargo"
          id="position"
          name='position'
          value={values.position}
          variant="outlined"
          InputLabelProps={{ shrink: true }}
          onChange={handleChange}
          fullWidth
          disabled={isDisabled}
        />
        <TextField
          label="Departamento"
          id="department"
          name='department'
          value={values.department}
          variant="outlined"
          InputLabelProps={{ shrink: true }}
          onChange={handleChange}
          fullWidth
          disabled={isDisabled}
        />
      </div>
      <div className='linha-campos'>
        <TextField
          label="Data de Admissão"
          id="admissionDate"
          name='admissionDate'
          value={values.admissionDate}
          variant="outlined"
          InputLabelProps={{ shrink: true }}
          onChange={handleChange}
          fullWidth
          disabled={isDisabled}
          type="date"
        />
        <NumericFormat
          customInput={TextField}
          label="Salário"
          id="salary"
          name='salary'
          value={values.salary}
          variant="outlined"
          InputProps={{
            startAdornment: <InputAdornment position="start">R$</InputAdornment>,
          }}
          fullWidth
          disabled={isDisabled}
          decimalSeparator=","
          decimalScale={2}
          autoComplete="off"
          onChange={handleChange}
          required
        />
        <Autocomplete
          id="employmentStatus"
          value={situacaoFuncional.find(option => option === values.employmentStatus)}
          options={situacaoFuncional}
          renderInput={(params) => <TextField {...params} label="Situação Funcional" variant="outlined" InputLabelProps={{ shrink: true }} />}
          fullWidth
          disabled={isDisabled}
          onChange={(e, newValue) => { setValues({...values, employmentStatus: newValue})}}
        />
      </div>

      <Typography variant="overline">Endereço</Typography>

      <div className='linha-campos'>
        <TextField
          label="Endereço"
          id='address'
          name='address'
          value={values.address}
          variant="outlined"
          InputLabelProps={{ shrink: true }}
          onChange={handleChange}
          fullWidth
          disabled={isDisabled}
        />
      </div>
      <div className='linha-campos'>
        <TextField
          label="Cidade"
          id='city'
          name='city'
          value={values.city}
          variant="outlined"
          InputLabelProps={{ shrink: true }}
          onChange={handleChange}
          fullWidth
          disabled={isDisabled}
        />
        <Autocomplete
          id="stateCode"
          value={ESTADOS_DO_BRASIL.find(option => option === values.stateCode)}
          options={ESTADOS_DO_BRASIL}
          renderInput={(params) => <TextField {...params} label="Estado" variant="outlined" InputLabelProps={{ shrink: true }} />}
          fullWidth
          disabled={isDisabled}
          onChange={(e, newValue) => { setValues({...values, stateCode: newValue})}}
        />
        <MaskedTextField
          mask='99.999-999'
          label="CEP"
          id='postalCode'
          name='postalCode'
          value={values.postalCode}

          variant="outlined"
          InputLabelProps={{ shrink: true }}
          onChange={handleChange}
          varibleName='cpfCnpj'
          fullWidth
          style={{ margin: '0' }}
          disabled={isDisabled}
        />
      </div>

      <Typography variant="overline">Outros</Typography>

      <div className='linha-campos'>
        <TextField
          label="Observações"
          id="observations"
          name='observations'
          value={values.observations}
          variant="outlined"
          InputLabelProps={{ shrink: true }}
          onChange={handleChange}
          fullWidth
          disabled={isDisabled}
        />
      </div>
    </CrudFormPage>
  )
}

FormEmpregados.propTypes = {
  values: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf([undefined])]),
    fullName: PropTypes.string.isRequired,
    birthDate: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
    cpf: PropTypes.string.isRequired,
    address: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
    city: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
    stateCode: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
    postalCode: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
    phone: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
    email: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
    admissionDate: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
    position: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
    department: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
    salary: PropTypes.string.isRequired,
    employmentStatus: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
    observations: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
    createdAt: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
    updatedAt: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
  }).isRequired,
  setValues: PropTypes.func.isRequired,
  isDelete: PropTypes.bool.isRequired,
  isLoadingSubmit: PropTypes.bool.isRequired,
}

export default FormEmpregados;